/**
 * @generated SignedSource<<47d0bcce75a38dbae4de7e3775f1e5f7>>
 * @relayHash 9e6bae8a1942ce883a3d1fc7f5b26901
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3e0bf4c698824530ba4bb0e11da2085d347499bce2d6efad6337c1a84ab677d7

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraIssueDeleteInput = {
  deleteSubtasks?: boolean | null | undefined;
  id: string;
};
export type deleteIssueView_deleteIssue_Mutation$variables = {
  input: JiraIssueDeleteInput;
};
export type deleteIssueView_deleteIssue_Mutation$data = {
  readonly jira_deleteIssue: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type deleteIssueView_deleteIssue_Mutation = {
  response: deleteIssueView_deleteIssue_Mutation$data;
  variables: deleteIssueView_deleteIssue_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "deleteIssueView_deleteIssue_Mutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraIssueDeletePayload",
        "kind": "LinkedField",
        "name": "jira_deleteIssue",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteIssueView_deleteIssue_Mutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraIssueDeletePayload",
        "kind": "LinkedField",
        "name": "jira_deleteIssue",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3e0bf4c698824530ba4bb0e11da2085d347499bce2d6efad6337c1a84ab677d7",
    "metadata": {},
    "name": "deleteIssueView_deleteIssue_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "ece7ea5729fe469a4366ac87e287255e";

export default node;
